import { render, staticRenderFns } from "./employee-list.vue?vue&type=template&id=455bf824&scoped=true&"
import script from "./employee-list.vue?vue&type=script&lang=js&"
export * from "./employee-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455bf824",
  null
  
)

export default component.exports